<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper register-surv">
    <div class="container-fluid">
      <div class="login-wrapper">
        <div class="login-inbox">
          <div class="log-auth">
            <div class="login-auth-wrap">
              <div class="login-content-head">
                <h3>
                  <span v-if="isNewAccount">Set a Password</span>
                  <span v-else>Reset Password</span>
                </h3>
                <p v-if="message" class="text-success">{{message}}</p>
                <p v-else-if="!isNewAccount">Your new password must be different from previous used passwords.</p>

                <p v-if="error" class="text-danger">{{ error }}</p>
              </div>
            </div>

            <form>
              <div class="form-group">
                <label class="form-label"> <span v-if="!isNewAccount">New </span>Password <span>*</span></label>
                <div class="pass-group" id="passwordInput">
                  <input
                    v-if="showPassword"
                    type="text"
                    class="form-control pass-input"
                    v-model="password"
                    placeholder="**********"
                  />
                  <input
                    v-else
                    type="password"
                    class="form-control pass-input"
                    placeholder="**********"
                    v-model="password"
                  />
                  <span
                    class="toggle-password"
                    @click="toggleShow"
                    :class="{
                      'feather-eye': showPassword,
                      'feather-eye-off': !showPassword,
                    }"
                  ></span>
                </div>
              </div>

              <div class="form-group reset-group">
                <label class="form-label">Confirm Password <span>*</span></label>
                <div class="pass-group">
                  <input
                    v-if="showPassword1"
                    type="text"
                    class="form-control pass-input"
                    v-model="password1"
                    placeholder="**********"
                  />
                  <input
                    v-else
                    type="password"
                    class="form-control pass-input"
                    placeholder="**********"
                    v-model="password1"
                  />
                  <span
                    class="toggle-password"
                    @click="toggleShow1"
                    :class="{
                      'feather-eye': showPassword1,
                      'feather-eye-off': !showPassword1,
                    }"
                  ></span>
                </div>
              </div>
              <a
                href=""
                class="btn btn-primary w-100 btn-size justify-content-center"
                @click.prevent="resetPassword"
                >Submit</a
              >

              <router-link
                to="/login"
                class="btn btn-secondary w-100 btn-size justify-content-center mt-2"
              >Login
              </router-link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
export default {
  data() {
    return {
      showPassword: false,
      password: null,
      showPassword1: false,
      password1: null,
      message: '',
      error: '',
    };
  },

  computed: {
    isNewAccount() {
      return !!this.$route.query.activation;
    },
  },

  mounted() {
    if (this.$route.query.activation) {
      this.checkActivationCode();
    }
  },

  methods: {
    async checkActivationCode() {
      const r = await this.$store.dispatch('auth/checkActivationCode', this.$route.query.activation);
      console.log(r)
    },

    async resetPassword() {
      this.message = '';
      this.error = '';

      if (!this.password || !this.password1) {
        this.error = 'All fields are required';
        return;
      }

      if (this.password !== this.password1) {
        this.error = 'Passwords do not match';
        return;
      }

      const r = await this.$store.dispatch('auth/resetPassword', {
        password: this.password,
        password_confirmation: this.password1,
        email: this.$route.query.email,
        token: this.$route.query.activation ? this.$route.query.activation : this.$route.query.token,
      });

      if (r.success) {
        this.message = 'Password reset successfully';

        this.password = '';
        this.password1 = '';
      } else {
        this.error = 'Something went wrong. Please try again in a few moments.';
      }
    },

    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
  },
};
</script>
